export default {
  getCrewTopSheetDocument: (state) => state.crewTopSheetDocument,
};
